<script>
	import { db } from './firebase';
	import { fade } from 'svelte/transition';

	let todoitems = [];
	let newtodoitem;
	let updatetodoitem;
	let edit = false;

	db.collection('todolists')
	.orderBy('id', 'asc')
    .onSnapshot(data => {
	  todoitems = data.docs;
    });

	const addItem = () => {
		db.collection('todolists').add({
			id: new Date().getTime(),
			name: newtodoitem
		});
		newtodoitem = "";
	}

	const deleteItem = (id) => {
		db.collection('todolists').doc(id).delete();
	}

	const editItem = (id, name) => {
		edit = id;
		updatetodoitem = name;
	}

	const saveItem = (id) => {
		edit = false;
		db.collection('todolists').doc(id).update({
			name: updatetodoitem
		});
	}

</script>

<div class="container">
	<h4 class="mt-5 mb-4 font-weight-bold">TO-DO APP</h4>
	<div class="input-group pt-3">
		<input type="text" class="form-control" placeholder="Add To Do List" bind:value={newtodoitem} required>
		<button class="btn btn-primary rounded-0" on:click={addItem}>Add</button>
	</div>
	<hr>
	{#if todoitems}
		<ul class="list-unstyled">
		{#each todoitems as todoitem, index}
			<li class="d-flex justify-content-between">
				<strong class="mr-2">
					{(index + 1) <= 9 ? "0" + (index + 1) : (index + 1)}.
				</strong>
				<strong>{todoitem.data().name}</strong>
				<div class="btn-group">
					<button class="btn btn-info" on:click={() => editItem(todoitem.id, todoitem.data().name)}>Edit</button>
					<button class="btn btn-danger" on:click={() => deleteItem(todoitem.id)}>Delete</button>
				</div>
			</li>
			{#if edit === todoitem.id}
				<div class="input-group" transition:fade="{{duration:500}}">
					<input type="text" class="form-control" bind:value={updatetodoitem}>
					<button class="btn btn-success rounded-0" on:click={() => saveItem(todoitem.id)}>Save</button>
				</div>
			{/if}
			<hr>
		{/each}
		</ul>
	{/if}
</div>

<style>

</style>